'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeadGenFormContainer = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = require('react-redux');

var _reduxForm = require('redux-form');

var _reactIntl = require('react-intl');

var _Validator = require('containers/Sell/Validator');

var _Sagas = require('decorators/Sagas/Sagas');

var _decorator = require('helpers/decorator');

var _forms = require('helpers/forms');

var _verify = require('helpers/verify');

var _bound = require('redux/saga/entities/bound');

var _LeadGenForm = require('./LeadGenForm');

var _LeadGenForm2 = require('./LeadGenForm.saga');

var formConfig = {
  destroyOnUnmount: false,
  form: 'leadgen',
  validate: _Validator.Validator
};

var getError = (0, _forms.getFirstError)(formConfig.form);

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    formError: getError(state) || _bound.waitlistRequest.error(state),
    wasCaptured: !(0, _verify.isEmpty)(_bound.waitlistRequest.data(state))
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  onWaitlistRequest: _LeadGenForm2.joinWaitlist
};

var LeadGenFormContainer = exports.LeadGenFormContainer = (0, _decorator.decorateWith)(_reactIntl.injectIntl, (0, _reduxForm.reduxForm)(formConfig), (0, _decorator.withName)('LeadGenForm'), (0, _Sagas.withSagas)({ watch: _LeadGenForm2.watchLeadGenFormSagas }), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(_LeadGenForm.LeadGenForm);